export const logos = [
  {
    id: 1,
    src: "/bootcamps/google.svg",
    alt: "google",
    width: 50,
  },
  {
    id: 2,
    src: "/bootcamps/ibm.svg",
    alt: "IBM",
    width: 63,
  },
  {
    id: 3,
    src: "/bootcamps/harvard.svg",
    alt: "harvard-university",
    width: 95,
  },
  {
    id: 4,
    src: "/bootcamps/paypal.svg",
    alt: "paypal",
    width: 94,
  },
  {
    id: 5,
    src: "/bootcamps/yale.svg",
    alt: "yale",
    width: 58,
  },
  {
    id: 6,
    src: "/bootcamps/ku-leuven.svg",
    alt: "ku leuven",
    width: 69,
  },
];

export const speakers = [
  {
    id: 1,
    name: "Dipanjan Sarkar",
    designation:
      "Data Science Lead @Applied Materials Google Developer ML Expert",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Dipanjan Sarkar.png",
  },
  {
    id: 2,
    name: "Julián Darío Miranda-calle",
    designation: "Professor, Universidad Pontificia Bolivariana",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Julián Darío Miranda-calle.png",
  },
  {
    id: 7,
    name: "Farhan Mohammad",
    designation: "Data Scientist at PayPal | Data Science & ML Expert",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Farhan Mohammad.png",
  },
  {
    id: 8,
    name: "Pascal Wiltschko",
    designation:
      "Statistician at Deutsche Bahn | M.Sc. Statistics Student at KU Leuven",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Pascal Wiltschko.png",
  },
  {
    id: 3,
    name: "Sai Gayatri Vadali",
    designation: "Data Scientist, Tetrasoft ML & DS Trainer",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Sai Gayatri Vadali.png",
  },
  {
    id: 4,
    name: "Joinal Ahmed",
    designation: "Data Scientist, Halodoc ID Author, Speaker and Mentor",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Joinal Ahmed.png",
  },
  {
    id: 5,
    name: "Pranjal",
    designation:
      "Data Engineer, Halodoc ID Mentor, Google Summer of Code | Polyglot Programmer",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Pranjal.png",
  },
  {
    id: 6,
    name: "Tan Li Tung",
    designation:
      "Student at Universiti Teknologi PETRONAS | Data Scientist - Microsoft Certified AI Engineer",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Tan Li Tung.png",
  },
  {
    id: 9,
    name: "Dikscha Sapra",
    designation: "Software Engineer at HCL | Data Science Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Dikscha Sapra.png",
  },
  {
    id: 10,
    name: "Gunnika Batra",
    designation: "Data Scientist at DPhi | Deep Learning Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Gunnika Batra.png",
  },
  {
    id: 11,
    name: "Ravi Raj Dasari",
    designation: "SDE II @Skellam AI | Data Science Geek",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Ravi Raj Dasari.png",
  },
  {
    id: 12,
    name: "Aishwarya Jadhav",
    designation:
      "Big Data Engineer at Morgan Stanley | ML Engineer & Data Science Geek",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Aishwarya Jadhav.png",
  },
  {
    id: 13,
    name: "Ruben Kerkhofs",
    designation:
      "Data Science Intern at KPMG Belgium | M.Sc. Statistics Student at KU Leuven",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Ruben Kerkhofs.png",
  },
  {
    id: 14,
    name: "Banu Prakash Reddy Munnangi",
    designation:
      "Senior Cognitive AI Developer at Wipro Limited | Bayesian Lover",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Banu Prakash Reddy Munnangi.png",
  },
  {
    id: 15,
    name: "Sanyam Dhawan",
    designation:
      "Incoming SWE at JP Morgan Chase | ML & Data Science Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Sanyam Dhawan.png",
  },
  {
    id: 16,
    name: "Avi Tomar",
    designation: "Data Science & AI Geek",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Avi Tomar.png",
  },
  {
    id: 17,
    name: "Amit Chauhan",
    designation: "MBA, IIM Lucknow | AI/ML Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Amit Chauhan.png",
  },
  {
    id: 18,
    name: "Chanukya Patnaik",
    designation: "Co-founder, DPhi",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Chanukya Patnaik.png",
  },
  {
    id: 19,
    name: "Rohit Yadav",
    designation: "Bot Developer @CloudMotiv | Data Science Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Rohit Yadav.png",
  },
  {
    id: 20,
    name: "Sani Kamal",
    designation:
      "Lead Programmer @Ne Tech Solution | Machine Learning & Data Science Geek",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Sani Kamal.png",
  },
  {
    id: 21,
    name: "Deeksha Singh",
    designation:
      "Associate System Engineer at IBM | Data Science & Machine Learning Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Deeksha Singh.png",
  },
  {
    id: 22,
    name: "Rupakanth Gundralla",
    designation: "Data Scientist Trainee at Edyoda",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Rupakanth Gundralla.png",
  },
  {
    id: 23,
    name: "Billa Srikar",
    designation:
      "Material Informatics Enthusiast | Data Science & Machine Learning Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Billa Srikar.png",
  },
  {
    id: 24,
    name: "Utkarsh Uppal",
    designation:
      "Research Intern at National University of Singapore, ML Research Engineer at VisioLab",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Utkarsh Uppal.png",
  },
  {
    id: 25,
    name: "Adarsh Menon",
    designation:
      "Software Engineer @FiniteLoop | Machine Learning Enthusiast & Youtuber",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Adarsh Menon.png",
  },
  {
    id: 26,
    name: "Manish Kumar",
    designation: "Data Scientist at DPhi | Love Mathematics & Statistics",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Manish Kumar.png",
  },
  {
    id: 27,
    name: "Afaf Athar",
    designation:
      "Masters Student at Vellore Institute Of Technology | Ambassador at WomenTech Network",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Afaf Athar.png",
  },
  {
    id: 28,
    name: "Krishna Chandrapati",
    designation: "Master of Data Analytics - Deakin University",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Krishna Chandrapati.png",
  },
  {
    id: 29,
    name: "Harshita Agarwal",
    designation:
      "Trainee at LinuxWorld Informatics | Machine Learning & Deep Learning Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Harshita Agarwal.png",
  },
  {
    id: 30,
    name: "Shaurya Kumar",
    designation:
      "Software Engineer at JungleWorks | Machine Learning Enthusiast",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Shaurya Kumar.png",
  },
  {
    id: 31,
    name: "Agraha Jigyasu",
    designation:
      "Software Engineer Intern at Fidelity Investments | Undergraduate Student at NIT Warangal",
    imgSrc:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/coaches/Agraha Jigyasu.png",
  },
];

export const testimonialData = [
  {
    id: 1,
    name: "Giovanna Reggina Galleno Malaga | Milan - Italy",
    title: "Soft Skills Trainer",
    description:
      "I feel so lucky of being part of this amazing community that has helped me to change my life. Thank you so much DPhi team and coaches for making this possible!",
    image:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/testimonials/Giovanna%20Reggina%20Galleno%20Malaga.png",
    imageAlt: "Leidy jhoana Molina Sambony",
  },
  {
    id: 2,
    name: "Rackson Mathias | Calgary, Canada ",
    title: "Inventory Specialist ",
    description:
      "The course structure was easy to follow and anybody who is methodical, self-motivated, and interested to learn new skills will ace it. I am looking forward to applying my learnings on predictive analytics projects in my company shortly and thankful to DPhi for the opportunity.",
    image:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/testimonials/Rackson+Mathias.png",
    imageAlt: "Rackson Mathias",
  },
  {
    id: 3,
    name: "Deeksha Singh | Hyderabad, India",
    title: "Oracle Application Developer, IBM India",
    description:
      "I couldn’t have asked for a better start to my Data Science journey. I will forever be grateful to the entire team of Dphi for putting in all the  efforts and ensuring a hassle free, rich learning experience for all of us.",
    image:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/testimonials/Deeksha%20Singh.png",
    imageAlt: "Deeksha Singh",
  },
  {
    id: 4,
    name: "Baiye Randolf Takor | Cameroon",
    title: "Science Teacher,Enko Education",
    description:
      "I am always very enthusiastic about getting accurate information from data as well as making sound predictions. DPhi has greatly helped in fine-tuning my knowledge and practices. I intend to apply my learnings in deploying models in environmental systems as well as in business analytics.",
    image:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/testimonials/Baiye+Randolf+Takor.png",
    imageAlt: "Baiye Randolf Takor",
  },
  {
    id: 5,
    name: "Leidy jhoana Molina Sambony | Colombia",
    title: "Statistician",
    description:
      "The bootcamp course was a wonderful & very enriching experience on a professional level. The classes and themes were clear and with a high level, always accompanied by wonderful coaches willing to clear our concerns",
    image:
      "https://dphi.s3.ap-south-1.amazonaws.com/bootcamps/testimonials/Leidy%20jhoana%20Molina%20Sambony.png",
    imageAlt: "Leidy Molina",
  },
  {
    id: 6,
    name: "",
    image: "",
    imageAlt: "",
    title: "",
    description:
      "Still looking for motivation on why you need to be a part of the community? Look at what our learners have to say on LinkedIn:",
  },
];

export const FAQ_DATA = [
  {
    id: 1,
    question: "Who can attend Live Sessions by Experts?",
    answer:
      "Everyone is welcomed to attend the 'Live Sessions by Experts!' sessions. Simply register by filling the registration form above to get the details and links for all the upcoming sessions.",
  },
  {
    id: 2,
    question: "Are there any fees to pay?",
    answer:
      "Absolutely not! Live sessions by Experts is a community initiative driven towards our vision to build data culture and democratize data science learning. However, some invites-only sessions may require your registration beforehand.",
  },
  {
    id: 3,
    question: "What are the prerequisites to attend Live Sessions by Experts?",
    answer:
      "There are no prerequisites to attend Live Sessions by Experts. Your curiosity and desire to learn is all that you need to bring when you join us.",
  },
];

export const detailPageLogos = [
  {
    id: 1,
    src: "/bootcamps/google-detail-page.svg",
    alt: "google",
    width: 50,
  },
  {
    id: 2,
    src: "/bootcamps/ibm-detail-page.svg",
    alt: "IBM",
    width: 63,
  },
  {
    id: 3,
    src: "/bootcamps/harvard-detail-page.svg",
    alt: "harvard-university",
    width: 95,
  },
  {
    id: 4,
    src: "/bootcamps/paypal-detail-page.svg",
    alt: "paypal",
    width: 94,
  },
  {
    id: 5,
    src: "/bootcamps/yale-detail-page.svg",
    alt: "yale",
    width: 58,
  },
  {
    id: 6,
    src: "/bootcamps/ku-leuven-detail-page.svg",
    alt: "ku leuven",
    width: 69,
  },
];

